import { render } from "./TextPropsCmp.vue?vue&type=template&id=42949055"
import script from "./TextPropsCmp.vue?vue&type=script&lang=js"
export * from "./TextPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__